import React, { FC, memo, useCallback } from 'react';
import { ReactComponent as MapIcon } from 'shared/assets/icons/MapBlackIcon.svg';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Button, ButtonThemes } from 'shared/ui/Button';

interface ShowOnMapButtonProps {
  latitude: number;
  longitude: number;
  theme?: ButtonThemes;
  containerClassName?: string;
}

export const ShowOnMapButton: FC<ShowOnMapButtonProps> = memo((props) => {
  const { latitude, longitude, theme = 'primary', containerClassName } = props;

  const { t } = useAppTranslation('common');

  const handleShowOnMap = useCallback(() => {
    const googleMapsUrl = `https://yandex.ru/maps/?pt=${longitude},${latitude}&z=16&l=map`;

    window.open(googleMapsUrl, '_blank');
  }, [latitude, longitude]);

  return (
    <Button theme={theme} onClick={handleShowOnMap} /* icon={<MapIcon />} iconPosition="prev" */ containerClassName={containerClassName}>
      {t('Show on map')}
    </Button>
  );
});
